import { render, staticRenderFns } from "./STagInput.vue?vue&type=template&id=2685cd08&scoped=true&"
import script from "./STagInput.vue?vue&type=script&lang=js&"
export * from "./STagInput.vue?vue&type=script&lang=js&"
import style0 from "./STagInput.vue?vue&type=style&index=0&id=2685cd08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2685cd08",
  null
  
)

export default component.exports